import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

export interface ShiftCardData {
  id: string;
  rate: string;
  total: string;
  time: string;
  duration: string;
  facility: string;
  distance: string;
  role: string;
}

function DayBadge() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing="1.813px"
      sx={{
        background: (theme) => theme.palette.shift?.day.gradient,
        borderRadius: "14.503px",
        padding: "3.626px 7.251px",
      }}
    >
      <CbhIcon type="sun-filled" sx={{ width: 12, height: 12, color: "text.primary" }} />
      <Text
        sx={{
          fontSize: "10.877px",
          fontWeight: 500,
          lineHeight: "13.143px",
          color: "text.primary",
        }}
      >
        Day
      </Text>
    </Stack>
  );
}

export function ShiftCard({ data }: { data: ShiftCardData }) {
  return (
    <Box
      sx={{
        width: 310,
        backgroundColor: "background.quaternary",
        border: "0.906px solid rgba(0, 0, 0, 0.07)",
        borderRadius: "21.754px",
        padding: "14.503px",
        display: "flex",
        flexDirection: "column",
        gap: "14.503px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <DayBadge />
        <Stack spacing="1.813px" alignItems="flex-end">
          <Text
            sx={{
              fontSize: "14.503px",
              fontWeight: 500,
              lineHeight: "13.143px",
              color: "text.primary",
            }}
          >
            {data.rate}
          </Text>
          <Text
            sx={{
              fontSize: "12.69px",
              fontWeight: 400,
              lineHeight: "15.409px",
              letterSpacing: "-0.1269px",
              color: "text.tertiary",
            }}
          >
            {data.total}
          </Text>
        </Stack>
      </Box>

      <Stack spacing="10.877px">
        <Stack spacing="1.813px">
          <Stack direction="row" spacing="7.251px" alignItems="baseline">
            <Text
              sx={{
                fontSize: "14.503px",
                fontWeight: 500,
                lineHeight: "13.143px",
                color: "text.primary",
              }}
            >
              {data.time}
            </Text>
            <Text
              sx={{
                fontSize: "12.69px",
                fontWeight: 400,
                lineHeight: "15.409px",
                letterSpacing: "-0.1269px",
                color: "text.tertiary",
              }}
            >
              {data.duration}
            </Text>
          </Stack>
          <Stack direction="row" spacing="7.251px" alignItems="baseline">
            <Text
              sx={{
                fontSize: "12.69px",
                fontWeight: 400,
                lineHeight: "15.409px",
                letterSpacing: "-0.1269px",
                color: "text.secondary",
              }}
            >
              {data.facility}
            </Text>
            <Text
              sx={{
                fontSize: "12.69px",
                fontWeight: 400,
                lineHeight: "15.409px",
                letterSpacing: "-0.1269px",
                color: "text.tertiary",
              }}
            >
              {data.distance}
            </Text>
          </Stack>
        </Stack>
        <Text
          sx={{
            fontSize: "12.69px",
            fontWeight: 400,
            lineHeight: "15.409px",
            letterSpacing: "-0.1269px",
            color: "text.secondary",
          }}
        >
          {data.role}
        </Text>
      </Stack>
    </Box>
  );
}

export function ShiftDetailsButton() {
  return (
    <Box
      sx={{
        width: 310,
        backgroundColor: "common.white",
        border: "1px solid",
        borderColor: "border.primary",
        borderRadius: "90.643px",
        padding: "14.503px 18.129px",
        textAlign: "center",
      }}
    >
      <Text
        sx={{
          fontSize: "14.5px",
          fontWeight: 500,
          lineHeight: "15.409px",
          letterSpacing: "-0.145px",
          color: "text.primary",
        }}
      >
        Shift details
      </Text>
    </Box>
  );
}

export const SHIFT_CARDS: ShiftCardData[] = [
  {
    id: "shift-1",
    rate: "$24.87 /hr",
    total: "$161.66",
    time: "9:00 am - 5:00 pm",
    duration: "8h",
    facility: "American Orchards Senior Community",
    distance: "2 mi",
    role: "CNA",
  },
  {
    id: "shift-2",
    rate: "$24.87 /hr",
    total: "$161.66",
    time: "7:30 am - 2:00 pm",
    duration: "6h 30m",
    facility: "Growing Minds Learning Center",
    distance: "4 mi",
    role: "Lead Teacher",
  },
  {
    id: "shift-3",
    rate: "$52.32 /hr",
    total: "$366.24",
    time: "8:00 am - 3:00 pm",
    duration: "7h",
    facility: "Bright Smiles Dentistry",
    distance: "3 mi",
    role: "Dental Assistant",
  },
];
